import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var TableDeleteRow = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 28 28"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 13.25h7.73l.07.08.67.67-.67.67-.07.08H2.75a.75.75 0 0 1 0-1.5Zm14.45.08.07-.08h7.98a.75.75 0 0 1 0 1.5h-7.98a1.83 1.83 0 0 0-.07-.08l-.67-.67.67-.67Zm-4.67-1.86a.75.75 0 1 0-1.06 1.06L12.94 14l-1.47 1.47a.75.75 0 1 0 1.06 1.06L14 15.06l1.47 1.47a.75.75 0 1 0 1.06-1.06L15.06 14l1.47-1.47a.75.75 0 1 0-1.06-1.06L14 12.94l-1.47-1.47ZM25 3.75a.75.75 0 0 0-1.5 0v1.5c0 1.24-1 2.25-2.25 2.25H18.5V3.75a.75.75 0 0 0-1.5 0V7.5h-6V3.75a.75.75 0 0 0-1.5 0V7.5H6.75c-1.24 0-2.25-1-2.25-2.25v-1.5a.75.75 0 0 0-1.5 0v1.5A3.75 3.75 0 0 0 6.75 9h14.5A3.75 3.75 0 0 0 25 5.25v-1.5Zm0 19A3.75 3.75 0 0 0 21.25 19H6.75A3.75 3.75 0 0 0 3 22.75v2.5a.75.75 0 0 0 1.5 0v-2.5c0-1.24 1-2.25 2.25-2.25H9.5v4.75a.75.75 0 0 0 1.5 0V20.5h6v4.75a.75.75 0 0 0 1.5 0V20.5h2.75c1.24 0 2.25 1 2.25 2.25v2.5a.75.75 0 0 0 1.5 0v-2.5Z"
  }));
});
TableDeleteRow.displayName = 'TableDeleteRow';
export var TableDeleteRowDimensions = {
  height: 28,
  width: 28
};